module.exports = __webpack_public_path__ + "img/added-list.75b68217.svg";